import axios from 'axios'
import { getToken, signOut } from './AuthService'

let tenantId: string
export function setTenantId (tenant: string): void {
  tenantId = tenant
}
export function getTenantId (): string {
  return tenantId
}

export default (): void => {
  axios.defaults.baseURL = process.env.REACT_APP_API
  axios.defaults.headers.post['Content-Type'] = 'application/json'

  if (tenantId) {
    axios.defaults.headers.post['X-TENANT-ID'] = tenantId
  }

  // Intercept Request
  axios.interceptors.request.use(
    config => {
      const { token } = getToken()
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      } else {
        delete config.headers.Authorization
      }

      if (tenantId) {
        config.headers['X-TENANT-ID'] = tenantId
      }

      // Handle locale
      const locale = localStorage.getItem('locale')
      const envLocale = process.env.REACT_APP_BASE_LOCALE
      config.headers.locale = locale || envLocale || 'en-US'

      return config
    },
    error => {
      return error
    }
  )

  // Intercept Response
  axios.interceptors.response.use(
    response => {
      if (response && response.data && response.data.code === 401) {
        signOut()
      }

      return response
    },
    error => {
      if (error.response && error.response.status === 401) {
        console.log('Sign Out 401')
        signOut()
      }
      return Promise.reject(error)
    }
  )
}
